module.exports = __webpack_public_path__ + "img/publikationfest.1230af44.jpg";